interface IGlobal {
  [key: string]: any
  isXlBox?: boolean
  fromSpace:string
}
const DATAS: IGlobal = {fromSpace: ''}

export function get (key: string) {
  return DATAS[key]
}

export function set (key: string, data: any) {
  DATAS[key] = data
}

const obj: IGlobal = {fromSpace: ''}

export default new Proxy(obj, {
  set (_, prop: string, value) {
    set(prop, value)
    return true
  },
  get (_, prop: string) {
    return get(prop)
  },
})
